@if (folderFormId || folderFormData) {
    <div class="gaps-between-sections">
        <div class="grid-2col input-grid-gaps">
            <div class="fr-2 font-bold">{{ 'form.criteria' | translate }}</div>
            <app-select-input
                id="ppsValue"
                [form]="form"
                label="form.pps.fields.ppsValue"
                [staticOptions]="options"
                valueKey="value"
                [autoDisplayFirst]="false">
            </app-select-input>
            <div></div>

            @for (key of ppsKeysExtra; track key) {
                <ng-container>
                    <div> {{ 'form.pps.fields.' + key | translate }}:</div>
                    <div class="font-bold">{{ values[key] }}</div>
                </ng-container>
            }
        </div>

        <div class="grid-2col_auto input-grid-gaps">
            <div class="fr-2 font-bold">{{ 'form.finalEvaluation' | translate }}</div>

            <app-text-area-input
                id="note"
                [form]="form"
                label="form.dekn.fields.note"
                class="fr-2"
            ></app-text-area-input>

            <div>{{ 'form.finalEvaluation' | translate }}:</div>
            <div class="font-bold">{{ finalEvaluation }}</div>

            <div>{{ 'form.totalPoints' | translate }}:</div>
            <div class="font-bold">{{ totalPoints }}</div>
        </div>

        <div class="grid-4col input-grid-gaps">
            <div class="fr-4 font-bold">{{ 'form.administration' | translate }}</div>
            <app-select-input
                [form]="form"
                id="user"
                [infiniteScroll]="store.userScroll()"
                valueKey="id"
                label="form.pps.fields.user"
            >
                <ng-template #item let-item>
                    {{ item | formatPerson }}
                </ng-template>
                <ng-template #selectedItem let-item>
                    {{ item | formatPerson }}
                </ng-template>
            </app-select-input>
            <app-date-input
                id="date"
                [form]="form"
                label="form.pps.fields.date"
            ></app-date-input>
        </div>

        <app-action-buttons
            [primaryButtonVisibility]="form.enabled"
            (primaryClickEvent)="submit()"
            (secondaryClickEvent)="closeForm.emit()"
        ></app-action-buttons>
    </div>
}
